// md_frontend/src/belediye/altbar.js
//
// ALT BAR YUVA SÖZLEŞMESİ (FAZ-90).
//
// KURAL: burada HİÇBİR rol string'i geçmez. Yuvalar yalnız izin kodlarından
// ve /me.enabled_modules'tan türer — nav.js'in FAZ-12'de kurduğu sözleşmenin
// aynısı. Rol adı bir `if` içine girerse admin'den rol düzenlemek barı
// değiştirmez ve sistem iki ayrı doğruluk kaynağına bölünür.
//
// Sıra ANLAMLIDIR: soldan sağa yazıldığı gibi çizilir. Merkez sohbet düğmesi
// çizim sırasında ortaya enjekte edilir (bkz. AltBar.js).
//
// Nöbetçi test: __tests__/altbar.turetim.faz90.test.js

/* FAZ-97 madde 1 — YUVA HANGİ ROTALARDA "AKTİF" SAYILIR?
   ---------------------------------------------------------------------------
   `NavLink`in kendi `isActive`i TAM YOL eşleşmesi yapıyor. Yönlendirilenler
   ayrı bir rota (`/yonetim/yonlendirilen-basvurular`), Başvurular yuvası ise
   `/yonetim/basvurular`a bakıyor → o sayfada HİÇBİR yuva aktif olmuyor ve
   kullanıcı "neredeyim" bilgisini kaybediyor.

   `end={false}` de kurtarmaz: gevşek eşleşme yalnız ÖNEK bakar,
   `/yonlendirilen-basvurular` ise `/basvurular`ın öneki değil — rotalar iç
   içe değil KARDEŞ.

   Bu yüzden her yuva kendi rota AİLESİNİ taşır. Desenler `^…$` çapalı;
   `BIRIM` kısmı legacy `:unitSlug` önekli rotaları kapsar
   (BelediyeNavbar'daki DETAY_DESENLERI ile aynı dil).

   DİKKAT — `[^/]+` TEK BAŞINA YETMEZ: `/yonetim/saha/gorevlerim` o kalıba da
   uyuyor ve hem Saha hem Talepler yuvasını aktif ediyordu (nöbetçi test
   yakaladı: "İKİ yuva aynı anda aktif olamaz"). Gerçek birim slug'ları
   `saha`, `sistem`, `halk-masasi` OLAMAZ — bunlar rota adı. Olumsuz
   ileri-bakış o üçünü dışarıda bırakıyor. */
const BIRIM = "(?:(?!saha/|sistem/|halk-masasi/)[^/]+/)?";
export const YUVALAR = [
  {
    key: "anasayfa",
    label: "Anasayfa",
    to: "/yonetim/dashboard",
    icon: "ev",
    permissions: ["dashboard.view"],
    eslesen: [new RegExp(`^/yonetim/${BIRIM}dashboard$`)],
  },
  {
    key: "basvurular",
    label: "Başvurular",
    to: "/yonetim/basvurular",
    icon: "kutu",
    permissions: ["applications.view"],
    eslesen: [
      new RegExp(`^/yonetim/${BIRIM}basvurular(?:/[^/]+)?$`),
      // Statü sayfaları ve Yönlendirilenler aynı ailenin üyeleri:
      // çip şeridinde yan yana duruyorlar (FAZ-97 madde 3).
      new RegExp(
        `^/yonetim/${BIRIM}(?:yeni|incelemedeki|cozulen|cozulemeyen|yonlendirilen)-basvurular$`,
      ),
    ],
  },
  // Halk Masası — kendi iki ekranı. applications.view ile ÇAKIŞMAZ:
  // halk masası kullanıcısında applications.view yoktur.
  {
    key: "hm-sorgu",
    label: "Sorgula",
    to: "/yonetim/halk-masasi/sorgu",
    icon: "ara",
    permissions: ["halk_masasi.citizen.search"],
    profil: "halk_masasi",
    eslesen: [/^\/yonetim\/halk-masasi\/(?:sorgu|vatandas\/[^/]+|basvuru\/[^/]+)$/],
  },
  {
    key: "hm-yeni",
    label: "Yeni Başvuru",
    to: "/yonetim/halk-masasi/yeni-basvuru",
    icon: "arti",
    permissions: ["halk_masasi.application.create"],
    profil: "halk_masasi",
    eslesen: [/^\/yonetim\/halk-masasi\/(?:vatandas\/[^/]+\/)?yeni-basvuru$/],
  },
  // Saha — kendi atama ekranı. internal_tasks modülünden BAĞIMSIZ
  // (o ayrı bir modül: assignments).
  {
    key: "saha",
    label: "Saha",
    to: "/yonetim/saha/gorevlerim",
    icon: "saha",
    permissions: ["assignments.feedback.create"],
    eslesen: [
      /^\/yonetim\/saha\/gorevlerim(?:\/[^/]+)?$/,
      /^\/yonetim\/[^/]+\/saha(?:\/[^/]+)?$/,
    ],
    // Yalnız SAF saha deneyiminde çizilir; müdür de bu izne sahip ama
    // onun barında Saha yuvası olmamalı.
    profil: "saha",
  },
  {
    key: "talepler",
    label: "Talepler",
    to: "/yonetim/talepler", // FAZ-91: taraf seçimi sayfanın kendi işi
    icon: "gorev",
    permissions: [
      "tasks.view_created",
      "tasks.view_assigned",
      "tasks.view_unit_pool",
    ],
    modul: "internal_tasks",
    // Talepler kapısı iki listeyi de çiziyor; talep DETAYI da bu aileye ait.
    eslesen: [
      new RegExp(`^/yonetim/${BIRIM}(?:talepler|gorev-ata|gorevlerim)$`),
      new RegExp(`^/yonetim/${BIRIM}gorevler(?:/[^/]+)?$`),
    ],
  },
  // Sistem Yönetimi
  {
    key: "sy-kullanicilar",
    label: "Kullanıcılar",
    to: "/yonetim/sistem/kullanicilar",
    icon: "kisi",
    permissions: ["users.view"],
    eslesen: [/^\/yonetim\/sistem\/kullanicilar(?:\/[^/]+)?$/],
  },
  {
    key: "sy-roller",
    label: "Roller",
    to: "/yonetim/sistem/roller",
    icon: "kalkan",
    permissions: ["roles.manage", "permissions.catalog.view"],
    eslesen: [/^\/yonetim\/sistem\/roller(?:\/[^/]+)?$/],
  },
  {
    key: "sy-birim-agaci",
    label: "Birim Ağacı",
    to: "/yonetim/sistem/birim-agaci",
    icon: "bina",
    permissions: ["units.view", "units.manage", "units.manage_tree"],
    eslesen: [/^\/yonetim\/sistem\/birim-agaci$/],
  },
  // Profil — izinsiz, herkeste, HER ZAMAN SONUNCU (K-3).
  // DİKKAT: bu yuva rotaya GİTMEZ, menü açar (Profil / Çıkış yap).
  // Kullanıcı: "buradaki profile tıklanınca çıkış yap ve profil seçenekli
  // olsun." Bu yüzden `to` yok, `menu: true` var.
  {
    key: "profil",
    label: "Profil",
    to: null,
    icon: "kisi",
    permissions: null, // null = izin gerektirmez
    hepZaman: true,
    menu: true,
  },
];

/** Yan yuvanın üst sınırı. Merkez bunun dışında. */
export const AZAMI_YAN_YUVA = 4;

/* FAZ-99 / Y-5 — "BU TALEBİN SOHBETİNİ AÇ" KÖPRÜSÜ, ARTIK BURADA.
   ---------------------------------------------------------------------------
   Olay adı FAZ-90'da `components/AltBar.js` içinde tanımlanmıştı; GorevDetayPage
   onu dinliyor, alt bar yayınlıyordu. FAZ-99'da İKİNCİ bir yayıncı gerekti:
   tablette sohbet başlatıcı balonu (ChatDock) de aynı soruyu soruyor.

   ChatDock'un `AltBar.js`ten içe aktarması DAİRESEL olurdu — AltBar zaten
   ChatDock'tan `UNREAD_EVENT` çekiyor. Bu dosya saf veri (hiçbir şey içe
   aktarmıyor), bu yüzden ortak ata olarak doğru yer burası.
   `AltBar.js` geriye uyum için yeniden dışa aktarıyor. */
export const GOREV_SOHBET_EVENT = "gorev:sohbet-ac";

/**
 * Görünür yan yuvaları türetir. SAF fonksiyon — testin öznesi budur.
 *
 * @param {string[]} permissions      /me.permissions
 * @param {object}   enabledModules   /me.enabled_modules (eksikse hepsi açık sayılır)
 * @param {string|null} uiProfile     /me.ui_profile ("saha" | "halk_masasi" | …)
 * @returns {Array} YUVALAR alt kümesi, sıra korunur, en fazla AZAMI_YAN_YUVA
 */
export function gorunurYuvalar(permissions, { enabledModules, uiProfile } = {}) {
  const set = new Set(Array.isArray(permissions) ? permissions : []);
  const modulAcik = (ad) =>
    !ad || !enabledModules || enabledModules[ad] !== false;

  const uygun = YUVALAR.filter((y) => {
    if (!modulAcik(y.modul)) return false; // K-8
    if (y.profil && uiProfile !== y.profil) return false; // saha/HM yalnız kendi profilinde
    if (y.hepZaman) return true; // profil
    if (!y.permissions) return true;
    return y.permissions.some((p) => set.has(p)); // canAny
  });

  // Profil her zaman SONUNCU. Diğerleri sıralarını korur.
  const profil = uygun.filter((y) => y.hepZaman);
  const digerleri = uygun.filter((y) => !y.hepZaman);

  // Taşma: profil hariç ilk (AZAMI_YAN_YUVA - profil) tanesi barda, gerisi
  // yalnız çekmecede kalır. Sessiz kırpma DEĞİL — çekmecede hepsi duruyor,
  // kullanıcı hiçbir şey kaybetmiyor.
  const kalan = Math.max(0, AZAMI_YAN_YUVA - profil.length);
  return [...digerleri.slice(0, kalan), ...profil];
}

/**
 * FAZ-97 madde 1 — bu yuva verilen rotada aktif mi?
 *
 * SAF fonksiyon; testin öznesi budur. `eslesen` yoksa `to` ile tam eşleşmeye
 * düşer — yeni bir yuva desen yazmayı unutursa eski davranış geçerli kalır,
 * sessizce "hep aktif" olmaz.
 */
export function yuvaAktifMi(yuva, pathname) {
  if (!yuva || !pathname) return false;
  const yol = String(pathname).replace(/\/+$/, "") || "/";
  if (Array.isArray(yuva.eslesen) && yuva.eslesen.length) {
    return yuva.eslesen.some((d) => d.test(yol));
  }
  return Boolean(yuva.to) && yol === yuva.to.replace(/\/+$/, "");
}

/** Merkez sohbet düğmesi çizilecek mi? */
export function sohbetAcikMi(enabledModules) {
  return !enabledModules || enabledModules.mesajlasma !== false;
}

/** Merkezin yan yuvalar arasındaki konumu (kaçıncı yuvadan SONRA girer). */
export function merkezKonumu(yanYuvaSayisi) {
  return Math.ceil(yanYuvaSayisi / 2);
}
